import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/new/null_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-41d8f612"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user_page" }
const _hoisted_2 = { class: "home_box" }
const _hoisted_3 = { class: "learnShow" }
const _hoisted_4 = { class: "learn_list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "learn_progress" }
const _hoisted_7 = {
  key: 1,
  class: "null_box"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无数据", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "pagin_box"
}
const _hoisted_12 = { class: "pagin_tiao" }

import { defineComponent, onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { GetLearnTakeList } from '@/hooks/public' // 混入学习记录接口
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'learnTake',
  setup(__props) {

const store = useStore()
let person: any = reactive({
    typeActive: 0,
    // 学习记录列表：
    data: {
      list: [],
      PageIndex: 1,
      PageSize: 10,
      total:0
    }
})
onMounted(() => {
    if (router.currentRoute.value.name !== 'teaIndex') {
        store.commit('setIsBg', true)
    }
})
let router = useRouter();
let toStudy = (item: any) => {
    let obj = { Id: item.RecordSectionId, NodeId: item.RecordChapterId, IsCollect: 1 }
    localStorage.setItem('setId', JSON.stringify(obj))
    let obj1 = { isOpenClass:true }
    localStorage.setItem('openClass', JSON.stringify(obj1))
    router.push({ name: 'recordDetails' })
}

// 获取学习记录列表
GetLearnTakeList(person.data, 1)
// 分页
const currentChange = (val: number) => {
    person.data.PageIndex = val
    GetLearnTakeList(person.data, 1)
}

return (_ctx: any,_cache: any) => {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "seachTop",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_ArrowLeft)
          ]),
          _: 1
        }),
        _createTextVNode(" 学习记录 ")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(person).data.list&&_unref(person).data.list.length>0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(person).data.list, (learn, leIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "learn_item",
                  key: leIndex,
                  onClick: ($event: any) => (_unref(toStudy)(learn))
                }, [
                  _createElementVNode("span", null, _toDisplayString(learn.SectionName), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_progress, {
                      percentage: Number(learn.Progress).toFixed(2)==='0.00'?0:Number(learn.Progress).toFixed(2),
                      color: "#EA5617",
                      "stroke-width": "12"
                    }, null, 8, ["percentage"])
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_unref(person).typeActive !== 2 ? '主讲：' + learn.TeacherName :''), 1)
                ], 8, _hoisted_5))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10)),
          (_unref(person).data.total > _unref(person).data.PageSize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_el_pagination, {
                  layout: "prev, pager, next, jumper",
                  "current-page": _unref(person).data.PageIndex,
                  "page-size": _unref(person).data.PageSize,
                  total: _unref(person).data.total,
                  onCurrentChange: currentChange
                }, null, 8, ["current-page", "page-size", "total"]),
                _createElementVNode("div", _hoisted_12, "每页 " + _toDisplayString(_unref(person).data.PageSize) + " 条，共 " + _toDisplayString(_unref(person).data.total) + " 条", 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})